<template>
    <v-dialog persistent scrollable v-model="dialog" maxWidth="680">
        <template #activator="{on}">
            <div class="d-flex align-center">
                <div class="d-flex align-center flex-grow-1 mr-2" v-on="on">
                    <div class="defaultSlot flex-grow-1">
                        <label>
                            {{ label }}
                        </label>
                        {{ product ? product.name : '-- Choose --' }}
                    </div>
                    <div v-if="value" @click.stop="clear()">
                        <v-icon>mdi-close</v-icon>
                    </div>
                </div>
                <div v-if="!value">
                    <v-btn outlined x-small @click="useCurrent()">Use current</v-btn>
                </div>
            </div>
        </template>
        <v-card :loading="isLoading" :disabled="isLoading">
            <v-card-text>
                <v-row dense>
                    <v-col>
                        <v-text-field v-model="term" label="Search" clearable ref="term"/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <Brand v-model="filters.brand"/>
                    </v-col>
                    <v-col>
                        <v-radio-group v-model="filters.dominantHand" row>
                            <v-radio label="RH" value="rh"/>
                            <v-radio label="LH" value="lh" />
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <ProductType v-model="filters.classification" label="Type" :items="productTypes" multiple disabled/>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col>
                        <v-row v-for="item in items" :key="item.id" dense>
                            <v-col>
                                <v-card @click="selectProduct(item)">
                                    <v-card-text class="d-flex align-center">
                                        <v-chip small class="mr-4" outlined>
                                            <v-icon small :color="item.available > 0 ? 'success': 'error'" class="mr-2">mdi-circle</v-icon>
                                            stock: {{ item.available }}
                                        </v-chip>
                                        {{ item.name }}
                                        <v-spacer />
                                        <div>
                                            <v-chip small outlined>{{ item.type }}</v-chip>
                                            <v-spacer />
                                            <v-chip small outlined>{{ getPrice(item) }}</v-chip>
                                        </div>
                                        
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row v-if="items && items.length">
                    <v-col>
                        <v-pagination
                            v-model="page"
                            :length="pages"
                        />
                    </v-col>
                </v-row>
                <v-row v-else-if="items">
                    <v-col>
                        No result
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined color="error" @click="cancel()">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
import { mapActions } from 'vuex'
import Brand from '../select/Brand'
import ProductType from '../autocomplete/ProductType'

export default {
    name: 'ProductSelection',
    components: { ProductType, Brand },
    props: {
        label: {
            type: String,
            default: () => 'Product'
        },
        value: {
            type: [Number, String],
            default: null
        },
        rules: {
            type: Array,
            default: () => null
        },
        dominantHand: {
            type: String,
            default: () => ''
        },
        type: {
            type: Array,
            default: () => []
        },
        catalogId: {
            type: Number,
            default: null
        },
        currency: {
            type: String,
            required: true
        }
    },
    data: () => ({
        term: '',
        dialog: false,
        filters: {
            status:'active'
        },
        isLoading: false,
        items: null,
        product: null,
        page: null,
        pages: null,
        productTypes: []
    }),
    mounted () {
        this.getProductTypes()
            .then(({types}) => {
                this.productTypes = types
            })
        this.setDefaultValue()
        if (this.value) {
            this.getProduct({id:this.value})
                .then(({data}) => {
                    this.selectProduct(data)
                })
        }
    },
    computed: {
        model: {
            get () {
                return this.value
            },
            set (v) {
                this.$emit('input', v)
            }
        },
        datas () {
            return `${this.dominantHand}|${this.type.join('')}|${this.catalogId}`
        }
    },
    methods: {
        ...mapActions('products', { getProductTypes: 'getProductTypes', searchProduct: 'index', getProduct: 'get' }),
        cancel () {
            this.items = null
            this.dialog = false
        },
        setDefaultValue () {
            const filters = {
                dominantHand: this.dominantHand,
                classification: this.type,
                catalogId: this.catalogId,
                status: 'active'
            }

            this.filters = filters
            
        },
        selectProduct(item) {
            this.model = item.id
            this.product = item
            this.cancel()
        },
        doSearch () {
            this.isLoading = true
            this.searchProduct ({
                search: this.term,
                filters: this.filters,
                pagination: {
                    itemsPerPage: 5,
                    page: this.page
                }
            })
            .then(({products}) => {
                this.items = products.data
                this.pages = products.last_page
                this.page = products.current_page
            })
            .finally(() => (this.isLoading = false));
        },
        getPrice(item) {
            if(!item.prices.length){
                return 'undefined'
            }

            const price = item.prices.find(p => p.currency == this.currency) ?? item.prices[0]

            return `${price.price} ${price.currency}`
        },
        clear () {
            this.model = null
            this.product = null
        },
        useCurrent() {
            this.searchProduct ({
                search: 'current',
                filters: this.filters,
                pagination: {
                    itemsPerPage: 1,
                    page: 1
                }
            })
            .then(({products}) => {
                if(products.data && products.data.length){
                    this.model = products.data[0].id
                    this.product = products.data[0]
                }
            })
        }
    },
    watch: {
        datas () {
            this.setDefaultValue()
        },
        filters: {
            deep: true,
            handler () {
                this.doSearch()
            }
        },
        term: {
            handler: _.debounce(function () {
                    this.doSearch()
            }, 400)
        },
        page(){
            this.doSearch()
        },
        dialog: {
            handler: _.debounce(function (v) {
                if (v) {
                    this.page=1
                    this.pages=null
                    this.$refs.term.focus()
                    this.doSearch()
                }
            }, 400)
        },
    }
}
</script>

<style lang="less" scoped>
.defaultSlot{
    display: flex;
    flex-direction: column;
    justify-content: center;
    label {
        color: #616161;
        display: block;
        margin-bottom: 2px;
    }
}
</style>